import React from "react";
import { InfoBoxTitle, InfoBoxWrapper } from "../Styled";
import { StyledTextArea } from "./Styled";

interface NoteProps {
    text: string;
    setText: Function;
    isView?: boolean;
}

const Note = ({ text, setText, isView }: NoteProps) => {
    return (
        <InfoBoxWrapper>
            <InfoBoxTitle>Ghi chú đơn hàng</InfoBoxTitle>
            {!isView && (
                <StyledTextArea
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    placeholder="Nhập ghi chú đơn hàng tại đây"
                />
            )}

            {isView && <div className="text">{text}</div>}
        </InfoBoxWrapper>
    );
};

export default Note;
